import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'hooks/useAppDispatch'
import { getSupportSocials } from 'actions/support.action'
import { RootState } from 'reducers/rootReducer'
import { TranslationKeys } from 'types/TranslationKeys'

export interface CardProps {
  isAr: boolean
  t: (key: TranslationKeys) => string
}

export const useCard = (props: CardProps) => {
  const dispatch = useAppDispatch()

  const supportSocials = useSelector(
    (state: RootState) => state.support.supportSocials
  )

  useEffect(() => {
    if (!supportSocials) dispatch(getSupportSocials())
  }, [supportSocials])

  return {
    ...props,
    supportSocials,
  }
}
